import { Routes, Route } from 'react-router-dom'

import AddCustomer from 'pages/AddCustomer'
import Customer from 'pages/Customer'
import Customers from 'pages/Customers'
import EditCustomer from 'pages/EditCustomer'
import NotFound from 'pages/NotFound'

import { useFeaturesContext } from 'hooks/FeaturesContext'

const CustomersRouter = () => {
  const { enabledFeatures } = useFeaturesContext()

  return (
    <Routes>
      <Route path="/" index element={<Customers />} />
      <Route path="new" element={<AddCustomer />} />
      <Route path=":customerId" element={<Customer />} />
      <Route path=":customerId/edit" element={<EditCustomer />} />
      <Route path=":customerId/systems/:deviceId" >
        <Route path=":activeTab" element={<Customer />} />
        <Route path="" element={<Customer />} />
      </Route>
      {enabledFeatures.includes('system_dashboard')? (
        <Route path=":customerId/systems/:deviceId/:activeTab" element={<Customer />} />
      ) : (
        <Route path=":customerId/systems/:deviceId/" element={<Customer />} />
      )}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default CustomersRouter
